import { createFileRoute } from '@tanstack/react-router'
import { PageRegionEdit } from '@/components/admin/regions/PageRegionEdit'
import { getAdminRegionEditLoaderFn } from '@/server/admin/admin.functions'

export const Route = createFileRoute('/admin/regions/$regionSlug/edit')({
  ssr: true,
  loader: ({ params }) => getAdminRegionEditLoaderFn({ data: { regionSlug: params.regionSlug } }),
  head: ({ loaderData }) => {
    if (!loaderData) return { meta: [] }
    return {
      meta: [{ title: `${loaderData.region.fullName} bearbeiten – ADMIN TILDA` }],
    }
  },
  component: PageRegionEdit,
})
